import React from "react";
import tw from "twin.macro";
import styled, { css } from "styled-components";

const Container = styled.div`
  ${tw`relative -mx-8 font-work_sans`}
  padding-top: clamp(2.5rem, 2rem + 2vw, 4rem);
`;

const TwoColumn = tw.div`flex flex-col lg:flex-row bg-[#FAB600] text-[#14133B] min-h-screen`;

const LeftColumn = tw.div`px-8 xl:pl-12 pt-10 pb-16 lg:w-1/2 flex flex-col justify-center min-h-[50vh] lg:min-h-0`;

const RightColumn = styled.div(({ $bg }) => css`
  ${tw`w-full`}
  position: relative;
  flex: 1 1 auto;
  min-height: 50vh;
  background-color: #fab600;
  background-image: url("${$bg}");
  background-size: cover;
  background-position: center;

  @media (min-width: 1024px) {
    flex: none;
    width: 50%;
    min-height: auto;
    background-image: none;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6rem 0;
  }
`);

const ImageBox = styled.div(({ $bg }) => css`
  display: none;

  @media (min-width: 1024px) {
    display: block;
    width: 78%;
    aspect-ratio: 4 / 5;
    border-radius: 30px;
    overflow: hidden;
    background-image: url("${$bg}");
    background-size: cover;
    background-position: center;
    box-shadow: 0 32px 60px rgba(20, 19, 65, 0.16);
  }
`);

const Content = tw.div`mt-2 lg:mt-6 mb-6 flex flex-col items-start text-left`;

const Heading = styled.h1`
  ${tw`text-3xl sm:text-5xl md:text-6xl tracking-tight uppercase`}
  line-height: 0.9;
  @media (min-width: 768px) {
    line-height: 1;
  }
`;

const Paragraph = styled.p`
  ${tw`mt-6 lg:mt-10 leading-snug text-base sm:text-lg`}
  max-width: 44rem;
`;

const SupportingText = styled.p`
  ${tw`mt-4 text-sm sm:text-base`}
  max-width: 36rem;
`;

const ButtonRow = tw.div`mt-10 flex flex-wrap items-center gap-4`;

const PrimaryButton = styled.a`
  ${tw`inline-flex items-center justify-center uppercase font-semibold`}
  padding: 0.85rem 2.8rem;
  border-radius: 999px;
  background: #14133b;
  color: #fab600;
  text-decoration: none;
  letter-spacing: 0.08em;
  
`;

const SecondaryButton = styled.a`
  ${tw`inline-flex items-center justify-center uppercase font-semibold`}
  padding: 0.85rem 2.6rem;
  border-radius: 999px;
  border: 1.5px solid #14133b;
  background: #fab600;
  color: #14133b;
  text-decoration: none;
  letter-spacing: 0.08em;
`;

const CareersComponent = ({
  onUploadClick,
  vacanciesUrl = "https://uk.indeed.com/m/jobs?q=Grain%20mediterranean&l=London%2C%20Greater%20London&from=searchOnHP&sameL=1",
  rightImage = "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/lifestyle-photos/Snipaste_2025-10-28_00-28-14.jpg",
}) => {
  return (
    <Container>
      <TwoColumn>
        <LeftColumn>
          <Content>
            <Heading>
              <span>JOIN THE TEAM</span>
              <br />
              <span>SHARE WHAT</span>
              <br />
              <span>YOU'RE MADE OF.</span>
            </Heading>

            <Paragraph>
              Grain thrives on sharp minds, generous hearts, and curious palates. If you're ready to grow with a fast-moving hospitality crew, we'd love to meet you.
            </Paragraph>
            <SupportingText>
              From culinary to operations and HQ roles, we invest in development, culture, and community. Let us know where you shine.
            </SupportingText>

            <ButtonRow>
              <PrimaryButton
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  onUploadClick?.();
                }}
              >
                Upload CV
              </PrimaryButton>
              {/* <SecondaryButton href={vacanciesUrl} target="_blank" rel="noopener">
                Current Vacancies
              </SecondaryButton> */}
            </ButtonRow>
          </Content>
        </LeftColumn>

        <RightColumn $bg={rightImage}>
          <ImageBox $bg={rightImage} aria-hidden="true" />
        </RightColumn>
      </TwoColumn>
    </Container>
  );
};

export default CareersComponent;
